var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTranslate = function SvgTranslate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6663 2.49984C16.6663 2.0396 16.2932 1.6665 15.833 1.6665H4.16634C3.7061 1.6665 3.33301 2.0396 3.33301 2.49984V17.4998C3.33301 17.9601 3.7061 18.3332 4.16634 18.3332H9.16634V16.6665H4.99967V3.33317H14.9997V7.49984H16.6663V2.49984Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.862 15.6494L15.0593 18.6427C15.1892 18.9674 15.5079 19.1764 15.8575 19.1661C16.207 19.1559 16.513 18.9285 16.6236 18.5967L19.5402 9.84669C19.6401 9.54725 19.5621 9.21711 19.3389 8.99392C19.1157 8.77072 18.7856 8.69279 18.4862 8.7926L9.73615 11.7093C9.40439 11.8199 9.17697 12.1258 9.1667 12.4754C9.15643 12.8249 9.36549 13.1437 9.69018 13.2736L12.6835 14.4709L11.4938 15.6606L12.6723 16.8391L13.862 15.6494ZM14.4758 13.3928L12.4214 12.571L17.4321 10.9008L15.7618 15.9114L14.9401 13.857C14.8554 13.6453 14.6876 13.4775 14.4758 13.3928Z",
    fill: "white"
  }))));
};
export { SvgTranslate as ReactComponent };
export default __webpack_public_path__ + "assets/c0d82353.svg";